import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { MemoriesPage } from "./pages/MemoriesPage";
import { MemoryDetailPage } from "./pages/MemoryDetailPage";
import { LoveNotesPage } from "./pages/LoveNotesPage";
import { SecretPage } from "./pages/SecretPage";

function App() {
  return (
    <div className="App grain-overlay">
      <BrowserRouter>
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/memories" element={<MemoriesPage />} />
            <Route path="/memories/:slug" element={<MemoryDetailPage />} />
            <Route path="/notes" element={<LoveNotesPage />} />
            <Route path="/secret" element={<SecretPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
